import { render, staticRenderFns } from "./ReservationConfirm.vue?vue&type=template&id=255ec955&"
import script from "./ReservationConfirm.vue?vue&type=script&lang=js&"
export * from "./ReservationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports